module.exports = __webpack_public_path__ + "guiding-principles-1.svg?f51cc81ef9f6a8f95aeaf55b48f79ddd";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/guiding-principles-1.svg
// module id = 45
// module chunks = 0